export default "__VITE_ASSET__B_dp5iVT__"